import type { SVGProps } from "react";
const SvgRemove = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fillRule="evenodd" d="M25 15a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2z" clipRule="evenodd" /></svg>;
export default SvgRemove;